import "../styles/Expired.scss";
import {useLocation} from "react-router-dom";
import {
  ArtistBackground,
  CharacterWithBubble,
  LanguageSelector,
} from "../components";
import {ARTIST, getArtistFromPath} from "../utils/artist.utils";
import {useTranslation} from "react-i18next";

const Expired = () => {
  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const {t} = useTranslation(artist);
  const {t: tCommon} = useTranslation("common");

  return (
    <div className="expired-container">
      <ArtistBackground artist={artist} />
      <div className="expired-header">
        <div />
        <LanguageSelector artist={artist} />
      </div>
      <div className="expired-content">
        <div className="expired-content-wrapper">
          <CharacterWithBubble
            content={t("expired.farewellMessage")}
            artist={artist}
            character={artist === ARTIST.aespa ? "karangi" : "rizuko"}
          />
          <div className="expired-text">{tCommon("expired.notice")}</div>
        </div>
      </div>
    </div>
  );
};

export default Expired;
